const countries = [
	{
		slug: 'dubai',
		flag: '🇦🇪',
		name: 'Dubai / VAE',
		subtitle: 'De belastingvrije toekomst in de woestijn',
		taxRate: '0%',
		taxLabel: 'Belasting op vermogen',
		pros: ['Geen inkomstenbelasting', 'Geen vermogensbelasting', 'Geen Box 3', 'Top lifestyle'],
		cons: ['40°C in de zomer', 'Ver van familie', 'Alcohol is duur', 'Strenge wetten'],
		color: '#c8960c',
		bgColor: '#fff8e1',
		content: {
			intro: `Dubai en de Verenigde Arabische Emiraten zijn uitgegroeid tot een van de populairste bestemmingen voor Nederlandse vermogenden die belastingvrij willen leven. Met geen inkomsten-, vermogens- of dividendbelasting is de fiscale aantrekkingskracht enorm — maar het dagelijks leven in de woestijn vraagt om een bewuste keuze.`,
			sections: [
				{
					title: 'Belastingvoordelen voor Nederlanders',
					body: `De VAE heffen geen inkomstenbelasting, geen vermogensbelasting en geen belasting op vermogenswinst. Voor een Nederlander die weg wil uit Box 3 is dit het meest radicale alternatief: in plaats van 36% op rendement betaal je simpelweg niets. Nederland heft na emigratie nog maximaal 10 jaar exitbelasting op bepaalde aanmerkelijk belangen — voor gewone beleggingsportefeuilles geldt dit echter niet. Raadpleeg een expat-belastingadviseur voor jouw situatie.`,
				},
				{
					title: 'Retirement Visa Dubai',
					body: `Sinds 2020 biedt Dubai een officieel Retirement Visa aan voor 55-plussers. Vereisten: minimaal €1 miljoen aan onroerend goed in de VAE, of een spaarsaldo van circa €250.000, of een maandelijks inkomen van minimaal €5.000. Het visum is vijf jaar geldig en verlengbaar. Er is geen minimale verblijfsduur, maar fiscale residency vereist doorgaans 183 dagen per jaar aanwezigheid.`,
				},
				{
					title: 'Kosten van levensonderhoud',
					body: `Dubai is duurder dan veel mensen verwachten. Een appartement in een gewilde wijk (Dubai Marina, Downtown, JBR) kost al snel €2.000–€4.000 per maand. Voedsel, restaurants en entertainment zijn vergelijkbaar met Amsterdam. Alcohol is alleen verkrijgbaar in hotels en gelicenseerde winkels — en fors belast. Autorijden is noodzakelijk; openbaar vervoer is beperkt buiten de metro.`,
				},
				{
					title: 'Praktische overwegingen',
					body: `De zomer (juni–september) is met temperaturen van 40–48°C en hoge luchtvochtigheid vrijwel onleefbaar buiten. Veel expats vertrekken drie maanden per jaar. De Nederlandstalige gemeenschap is aanwezig maar klein. Gezondheidszorg is van hoog niveau in de steden, maar privéverzekering is verplicht. Familierecht en sociale normen wijken sterk af van Nederlandse standaarden.`,
				},
			],
			cta: 'Wil je weten wat een fiscale verhuizing naar Dubai voor jouw portefeuille betekent?',
			advisorText: 'Vraag een gratis oriëntatiegesprek aan bij een gespecialiseerde expat-belastingadviseur.',
		},
	},
	{
		slug: 'portugal',
		flag: '🇵🇹',
		name: 'Portugal',
		subtitle: 'Zon, zee en lagere belastingen',
		taxRate: '10%',
		taxLabel: 'Vlak tarief (NHR-regeling)',
		pros: ['Stabiel klimaat', 'Goedkoop leven', 'Engelstalig', 'EU-land'],
		cons: ['NHR afgebouwd voor nieuwe gevallen', 'Bureaucratie', 'Lage lonen lokaal'],
		color: '#006b3c',
		bgColor: '#e8f5e9',
		content: {
			intro: `Portugal is jarenlang de nr. 1 bestemming geweest voor vroeggepensioeneerde Nederlanders — en hoewel het NHR-regime inmiddels veranderd is, blijft Portugal een van de meest aantrekkelijke EU-landen voor fiscale emigranten. De combinatie van mediterraan klimaat, goedkoop leven (buiten Lissabon), veiligheid en EU-lidmaatschap is uniek.`,
			sections: [
				{
					title: 'IFICI-regeling: de opvolger van NHR',
					body: `Het originele NHR (Non-Habitual Resident) regime eindigde voor nieuwe aanvragers in 2024. De opvolger, IFICI (Incentivo Fiscal à Investigação Científica e Inovação), richt zich primair op onderzoekers, hoogopgeleiden in innovatieve sectoren en startups. Voor gewone gepensioneerden is de klassieke NHR-korting van 10% op pensioeninkomsten niet meer automatisch beschikbaar. Wel bestaat de "Decreto-Lei" regeling waarbij buitenlands pensioeninkomen onder voorwaarden belastingvoordelen geniet. Raadpleeg een Portugese fiscalist voor de actuele situatie.`,
				},
				{
					title: 'D7 Visum — voor vroeggepensioneerden',
					body: `Als EU-burger heb je geen visum nodig om in Portugal te wonen. Je regelt gewoon een NIF (fiscaal nummer), opent een bankrekening en meldt je aan bij de gemeente. Binnen vijf jaar kun je permanent verblijf aanvragen. Het D7-visum is bedoeld voor niet-EU burgers met passief inkomen — als Nederlander is dit niet relevant.`,
				},
				{
					title: 'Kosten van levensonderhoud',
					body: `Buiten Lissabon en Porto is Portugal nog altijd betaalbaar. De Algarve (Faro, Lagos, Tavira) biedt uitstekende kwaliteit van leven voor €1.500–€2.500/mnd voor een stel. Huizen kopen of huren is goedkoper dan Nederland, al zijn de prijzen in toeristische zones flink gestegen. Boodschappen, restaurants en gezondheidszorg zijn significant goedkoper dan in Nederland.`,
				},
				{
					title: 'Leven als Nederlander in Portugal',
					body: `De Nederlandstalige gemeenschap in de Algarve is groot — je kunt er volledig in het Engels of zelfs Nederlands functioneren. Portugees leren helpt enorm voor bureaucratische zaken. Gezondheidszorg is van redelijke kwaliteit; particuliere verzekering is aan te raden. Portugal is politiek stabiel, veilig en heeft uitstekende vliegverbindingen naar Nederland (Eindhoven, Amsterdam → Faro/Lissabon).`,
				},
			],
			cta: 'Benieuwd hoeveel je bespaart door naar Portugal te emigreren?',
			advisorText: 'Laat een Portugese fiscalist jouw situatie doorrekenen.',
		},
	},
	{
		slug: 'singapore',
		flag: '🇸🇬',
		name: 'Singapore',
		subtitle: 'Aziatisch financieel centrum',
		taxRate: '0%',
		taxLabel: 'Vermogenswinst belasting',
		pros: ['Geen CGT', 'Stabiele economie', 'Veilig', 'Uitstekende zorg'],
		cons: ['Torenhoge huurprijzen', '32°C + 90% luchtvochtigheid', 'Ver weg', 'Kauwgom verboden'],
		color: '#c8102e',
		bgColor: '#fce4ec',
		content: {
			intro: `Singapore is het financiële centrum van Zuidoost-Azië en trekt vermogende expats met zijn nul procent belasting op vermogenswinst, politieke stabiliteit en wereld-topkwaliteit zorg en onderwijs. Het is echter niet goedkoop — en het klimaat is het hele jaar tropisch.`,
			sections: [
				{
					title: 'Fiscaal voordeel',
					body: `Singapore heft geen belasting op vermogenswinst, dividenden of buitenlandse inkomsten die niet in Singapore worden overgemaakt. Inkomstenbelasting geldt alleen voor lokaal verdiend inkomen en is progressief tot 22%. Voor iemand met een passieve beleggingsportefeuille die vanuit Singapore leeft van zijn vermogen is de belastingdruk feitelijk nul.`,
				},
				{
					title: 'Verblijfsvergunning',
					body: `Een Permanent Residence (PR) of Employment Pass is vereist voor langdurig verblijf. De Global Investor Programme (GIP) biedt PR aan vermogende individuen die minstens SGD 10 miljoen (circa €7 miljoen) investeren in Singapore. Dit maakt Singapore weinig toegankelijk voor de gemiddelde FIRE-er. Alternatieven zijn de EntrePass (voor ondernemers) of een Employment Pass via een eigen BV/entiteit.`,
				},
				{
					title: 'Kosten van levensonderhoud',
					body: `Singapore is een van de duurste steden ter wereld. Huren voor een expat-geschikte woning: SGD 4.000–10.000/mnd (€2.800–€7.000). Auto's zijn belastingtechnisch zo duur dat een Toyota Corolla €80.000+ kost. Eten in hawker centres (lokale eetcafés) is juist erg betaalbaar. Gezondheidszorg is uitstekend en ook zonder lokale verzekering toegankelijk, maar duur.`,
				},
				{
					title: 'Leven in Singapore',
					body: `Singapore is extreem veilig, schoon en efficiënt. Het publieke transport is wereldklasse. Engelstalig is de voertaal. Het klimaat — 32°C en 80–90% luchtvochtigheid het hele jaar — is voor sommigen heerlijk, voor anderen uitputtend. Er is geen Nederlandstalige gemeenschap van betekenis, maar de internationale expat-community is groot.`,
				},
			],
			cta: 'Singapore als financieel vrijhaven — is het realistisch voor jou?',
			advisorText: 'Bespreek de mogelijkheden met een internationaal belastingadviseur.',
		},
	},
	{
		slug: 'cyprus',
		flag: '🇨🇾',
		name: 'Cyprus',
		subtitle: 'EU-eiland met belastingvoordelen',
		taxRate: '0%',
		taxLabel: 'Belasting op aandelenwinst',
		pros: ['Geen CGT op aandelen', 'EU-lid', 'Mediterraan klimaat', 'Goedkoop leven'],
		cons: ['Kleine economie', 'Soms politieke spanningen', 'Bankcrisis verleden'],
		color: '#006b5b',
		bgColor: '#e0f2f1',
		content: {
			intro: `Cyprus is een EU-eiland in de oostelijke Middellandse Zee met aantrekkelijke belastingregels, een warm klimaat en lagere kosten dan West-Europa. Voor aandelenbeleggers is de nul procent kapitaalwinstbelasting de grootste troef.`,
			sections: [
				{
					title: 'Nul procent op aandelenwinst',
					body: `Cyprus heft geen belasting op vermogenswinst uit aandelen. Dividenden en rente-inkomsten zijn wel belast (via Special Defence Contribution), maar voor iemand die ETF's of groeiaandelen aanhoudt en verkoopt, is de belastingbesparing enorm. Inkomstenbelasting is progressief van 0% tot 35%, maar met Non-Domiciled status zijn buitenlandse dividend- en rente-inkomsten vrijgesteld voor maximaal 17 jaar.`,
				},
				{
					title: 'Non-Domiciled status',
					body: `Als je de Non-Dom status aanvraagt — beschikbaar voor nieuwe fiscale ingezetenen die geen Cypriotische "domicile of origin" hebben — betaal je 17 jaar lang geen belasting op buitenlandse dividenden en rente. Dit is bijzonder aantrekkelijk voor beleggers met een grote portefeuille die jaarlijks dividend uitkeert.`,
				},
				{
					title: 'Kosten van levensonderhoud',
					body: `Cyprus is aanmerkelijk goedkoper dan Nederland. Huren in Limassol (populairste expat-stad): €800–€2.000/mnd voor een goed appartement. Eten en drinken zijn betaalbaar. Het klimaat is uitstekend: 300+ zonnedagen per jaar, zachte winters. Limassol heeft een groeiende internationale community en moderne voorzieningen.`,
				},
				{
					title: 'Praktische informatie',
					body: `Als EU-burger heb je vrij vestigingsrecht op Cyprus. Engels is zeer breed gesproken — het eiland was tot 1960 Brits. Het rechtssysteem is gebaseerd op het Engelse Common Law, wat het voor Nederlanders herkenbaarder maakt dan Romaanse rechtsstelsels. De bankcrisis van 2013 is history maar heeft reputatieschade achtergelaten; Nederlandse media zijn kritischer over Cypriotische banken dan de realiteit rechtvaardigt.`,
				},
			],
			cta: 'Hoeveel bespaar jij op vermogenswinst door te emigreren naar Cyprus?',
			advisorText: 'Vraag een gratis berekening aan bij een Cypriotische belastingadviseur.',
		},
	},
	{
		slug: 'monaco',
		flag: '🇲🇨',
		name: 'Monaco',
		subtitle: 'Voor als het écht goed gaat',
		taxRate: '0%',
		taxLabel: 'Inkomstenbelasting',
		pros: ['Geen inkomstenbelasting', 'Ultiem prestige', 'Veiligste land ter wereld', 'F1 voor de deur'],
		cons: ['Huur: €10.000+/mnd', 'Je moet miljonair zijn', 'Heel klein', 'Niet voor normale mensen'],
		color: '#a6192e',
		bgColor: '#fce4ec',
		content: {
			intro: `Monaco is het kleinste onafhankelijke land van Europa en tegelijk de meest exclusieve fiscale vrijhaven van de westerse wereld. Geen inkomstenbelasting, geen vermogensbelasting — maar ook geen betaalbare woningen. Monaco is voor een zeer selecte groep.`,
			sections: [
				{
					title: 'Fiscaal regime',
					body: `Monaco heft geen inkomstenbelasting voor niet-Franse inwoners. Geen vermogensbelasting, geen erfbelasting voor directe familieleden, geen belasting op vermogenswinst. Franse staatsburgers zijn hiervan uitgesloten (belastingverdrag met Frankrijk). Voor Nederlanders geldt het volledige voordeel. Wel is er 20% BTW, net als in de EU.`,
				},
				{
					title: 'Residency vereisten',
					body: `Je moet aantonen dat je voldoende financiële middelen hebt (geen minimumbedrag vastgesteld maar €500.000+ is realistisch als drempel), een woning in Monaco bezitten of huren, en een bankrekening bij een Monegaskische bank openen. Na drie maanden ontvang je de "carte de résident." Er is geen belastingdrempel voor verblijfsdagen — je hoeft niet 183 dagen per jaar aanwezig te zijn.`,
				},
				{
					title: 'Kosten van levensonderhoud',
					body: `Monaco is de duurste vierkante meter ter wereld. Huren: €10.000–€50.000+/mnd voor een appartement. Kopen: €50.000–€100.000+ per m². Restaurants zijn zeer duur. De kosten worden gecompenseerd door het ontbreken van belasting — maar je hebt minimaal €5–10 miljoen aan vermogen nodig om dit comfortabel te doen.`,
				},
				{
					title: 'Leven in Monaco',
					body: `Monaco is 2,02 km² groot — kleiner dan het Vondelpark inclusief omgeving. Het is extreem veilig (meer bewakingscamera's per m² dan welk land ook), heeft wereldklasse restaurants en winkels, en een internationaal, meertalig netwerk van ultra high net worth individuals. De Formule 1 Grand Prix rijdt letterlijk door de straten. Ideaal voor wie privacy, veiligheid en status zoekt — niet voor wie ruimte en rust zoekt.`,
				},
			],
			cta: 'Monaco is niet voor iedereen — maar misschien wel voor jou?',
			advisorText: 'Laat een internationaal vermogensadviseur de haalbaarheid voor jouw situatie beoordelen.',
		},
	},
	{
		slug: 'zwitserland',
		flag: '🇨🇭',
		name: 'Zwitserland',
		subtitle: 'Forfaitaire belasting voor rijken',
		taxRate: 'Forfait',
		taxLabel: 'Op basis van levensstandaard',
		pros: ['Hoge levensstandaard', 'Politieke stabiliteit', 'Geen CGT federaal', 'Prachtige natuur'],
		cons: ['Erg duur', 'Moeilijk te immigreren', 'Niet in de EU', 'Deutsch/Frans/Italiaans leren'],
		color: '#d52b1e',
		bgColor: '#ffebee',
		content: {
			intro: `Zwitserland is Europa's meest stabiele land en heeft een uniek belastingstelsel: het lump sum regime (forfaitaire belasting) voor vermogende buitenlanders. Je betaalt belasting over een fictief inkomen gebaseerd op je levensstandaard — niet over je werkelijke vermogen of inkomen.`,
			sections: [
				{
					title: 'Lump Sum belasting',
					body: `Het Zwitserse "Pauschalbesteuerung" (lump sum) regime staat toe dat buitenlanders die niet in Zwitserland werken belasting betalen over een fictief inkomen — doorgaans vijf keer de jaarlijkse huurwaarde van hun woning. Voor iemand die een villa huurt voor €5.000/mnd is het belastbaar inkomen dus €300.000/jaar. Op €5 miljoen beleggingsinkomen betaal je dan effectief een zeer laag percentage. Beschikbaar in de kantons: Bern, Wallis, Waadt, Genève, Tessin en anderen.`,
				},
				{
					title: 'Geen federale CGT',
					body: `Op federaal niveau heft Zwitserland geen belasting op vermogenswinst uit aandelen voor particulieren die niet als professionele handelaar worden gezien. Kantonaal varieert dit. Dividenden zijn wel belast via bronbelasting (35%), maar hiervan is restitutie mogelijk via het belastingverdrag NL-CH.`,
				},
				{
					title: 'Immigratie vereisten',
					body: `Als EU-burger mag je in Zwitserland wonen (Vrij verkeer van personen verdrag CH-EU). Je hebt een B-vergunning nodig en moet aantonen dat je financieel zelfvoorzienend bent. De aanvraag voor het lump sum regime loopt via de kantonale belastingdienst. De drempel varieert per kanton maar is doorgaans minimaal CHF 400.000 belastbaar inkomen (forfait).`,
				},
				{
					title: 'Kosten van leven',
					body: `Zwitserland is na Monaco het duurste Europese land. Boodschappen zijn 2-3x duurder dan in Nederland. Huren in Genève of Zürich: €3.000–€8.000/mnd. De natuur, de rust, de stiptheid en de kwaliteit van leven zijn echter uitzonderlijk. Zwitserland is ideaal voor wie Europa's beste kwaliteit van leven zoekt en bereid is daarvoor te betalen.`,
				},
			],
			cta: 'Is het Zwitserse lump sum regime iets voor jou?',
			advisorText: 'Een Zwitserse fiscalist kan de minimale belastingdrempel voor jouw situatie berekenen.',
		},
	},
	{
		slug: 'thailand',
		flag: '🇹🇭',
		name: 'Thailand',
		subtitle: 'Tropisch leven voor een fractie van de prijs',
		taxRate: '0%',
		taxLabel: 'Op buitenlands vermogen (LTR visa)',
		pros: ['Erg goedkoop leven', 'Warm en zonnig', 'LTR-visum voor vermogenden', 'Geweldig eten'],
		cons: ['Geen EU-lidmaatschap', 'Taalbarrière', 'Gezondheidszorg buiten steden beperkt', 'Politieke instabiliteit'],
		color: '#a51931',
		bgColor: '#fce4ec',
		content: {
			intro: `Thailand is de go-to bestemming voor de kostenbewuste FIRE-er. Met een levensstijl die in Chiang Mai al haalbaar is voor €800–€1.200 per maand, een tropisch klimaat en het nieuwe LTR-visum dat fiscale vrijstelling biedt op buitenlands inkomen, is Thailand serieus in beeld voor vroeggepensioneerden.`,
			sections: [
				{
					title: 'LTR Visum (Long Term Resident)',
					body: `Sinds 2022 biedt Thailand het LTR-visum aan voor "Wealthy Pensioners": 50-plussers met minimaal $80.000 (circa €73.000) aan passief inkomen per jaar, of een vermogen van minimaal $250.000 met aanvullende ziektekostenverzekering. Het visum geeft 10 jaar verblijfsrecht met de mogelijkheid om 4 vrienden/familieleden mee te brengen. Fiscaal: inkomsten die vóór aankomst in Thailand zijn verdiend en die pas later worden overgemaakt zijn belastingvrij in Thailand.`,
				},
				{
					title: 'Belasting in Thailand',
					body: `Thailand belast alleen inkomen dat in hetzelfde kalenderjaar als waarop het werd verdiend naar Thailand wordt overgemaakt. Vermogenswinst uit beleggingen buiten Thailand is effectief onbelast als je dit goed structureert. Met een LTR-visum geldt bovendien een vlak tarief van 17% op lokaal inkomen — maar voor gepensioneerde beleggers is lokaal inkomen doorgaans nul.`,
				},
				{
					title: 'Kosten van levensonderhoud',
					body: `Chiang Mai is de populairste expat-bestemming: huur voor een goed appartement €300–€600/mnd, eten €5–€15/dag in lokale restaurants. Bangkok is duurder maar nog steeds goedkoop: €600–€1.500/mnd huur voor een westerse standaard. Phuket en Koh Samui zijn duurder en toeristische. De gemiddelde FIRE-er haalt een comfortabele lifestyle voor €1.000–€1.800/mnd.`,
				},
				{
					title: 'Praktische overwegingen',
					body: `Thais leren is moeilijk maar vriendelijkheid en Engels zijn breed aanwezig in expat-gebieden. Gezondheidszorg in Bangkok en Chiang Mai is van uitstekende internationale kwaliteit — privéziekenhuizen zijn betaalbaar. Buiten de steden neemt dit snel af. Politieke instabiliteit (coups) is historisch aanwezig maar treft expats doorgaans niet direct. Zomerhitte (maart–mei) kan extreme temperaturen bereiken (40°C+).`,
				},
			],
			cta: 'Thailand op €1.200/mnd — klopt jouw berekening met dit scenario?',
			advisorText: 'Bereken je scenario met lagere maandelijkse uitgaven in de calculator hierboven.',
		},
	},
	{
		slug: 'spanje',
		flag: '🇪🇸',
		name: 'Spanje',
		subtitle: 'Zon, tapas en de Beckham Law',
		taxRate: '0%',
		taxLabel: 'Op buitenlands vermogen (Beckham Law)',
		pros: ['0% op buitenlandse beleggingen (6 jaar)', 'Dichtbij Nederland', 'EU-land', 'Heerlijk klimaat'],
		cons: [
			'Na 6 jaar 19-28% (nog steeds < Box 3)',
			'Spaanse aandelen/rente wél belast',
			'Bureaucratie',
			'Huurprijzen Barcelona/Madrid gestegen',
		],
		color: '#c60b1e',
		bgColor: '#ffebee',
		content: {
			intro: `Spanje is de meest gekozen emigratiebestemming voor Nederlanders — dicht bij huis, EU-land, heerlijk klimaat en een grote Nederlandse gemeenschap langs de Costa's. De Beckham Law maakt het fiscaal ook voor vermogenden aantrekkelijk: zes jaar lang 0% op buitenlandse beleggingsinkomsten.`,
			sections: [
				{
					title: 'Beckham Law uitgelegd',
					body: `De Beckham Law (officieel: Régimen Especial para Trabajadores Desplazados, art. 93 IRPF) stelt dat nieuwe fiscale inwoners van Spanje gedurende zes jaar kunnen kiezen voor een vlak tarief van 24% op Spaans inkomen en 0% op buitenlands inkomen. Voor een Nederlander met een ETF-portefeuille bij DEGIRO of een buitenlandse bank betekent dit: zes jaar lang geen Spaanse belasting op dividenden, vermogenswinst of rente uit die portefeuille. Na zes jaar gelden de reguliere Spaanse tarieven (19–28% op spaargeld/vermogen — nog altijd lager dan Nederlandse Box 3 bij hogere rendementen).`,
				},
				{
					title: 'Aanvragen van de Beckham Law',
					body: `Je vraagt de Beckham Law aan via een Spaanse gestor (belastingadviseur) met formulier Modelo 149, binnen zes maanden na het verkrijgen van fiscale residency. Vereiste: je mag de afgelopen vijf jaar niet fiscaal inwoner van Spanje zijn geweest. Aanraders: zoek een gestor die ervaring heeft met buitenlanders (niet alle Spaanse belastingadviseurs kennen het regime goed).`,
				},
				{
					title: 'Beste regio\'s voor Nederlandse gepensioneerden',
					body: `Costa Blanca (Alicante, Torrevieja, Jávea) is de populairste regio voor Nederlanders: warm klimaat, betaalbaar (ook na stijgingen), grote Nederlandstalige gemeenschap, goede vliegverbindingen (Eindhoven–Alicante). Costa del Sol (Málaga, Marbella, Estepona) is luxueuzer en duurder. Canarische Eilanden (Tenerife, Gran Canaria) bieden het meest stabiele klimaat het hele jaar. Barcelona en Madrid zijn prachtig maar duur.`,
				},
				{
					title: 'Gezondheidszorg en praktisch leven',
					body: `Als EU-burger heb je recht op Spaanse gezondheidszorg zodra je fiscaal inwoner bent en je inschrijft bij de gemeente (empadronamiento). De kwaliteit van het publieke systeem is wisselend — in grote steden goed, in landelijke gebieden wachttijden. Particuliere verzekering (€50–€150/mnd) is aanbevolen voor comfort en snelheid. Spaans leren helpt enorm voor bureaucratie, maar in veel expat-gebieden kom je ver met Engels en Nederlands.`,
				},
			],
			cta: 'Bereken wat de Beckham Law voor jouw portefeuille betekent',
			advisorText: 'Een gespecialiseerde Spaans-Nederlandse belastingadviseur kan de exacte besparing voor jou doorrekenen.',
		},
	},
];

export default countries;
